import React, { useState, useEffect, useRef } from "react";
import { Checkbox, Radio } from "antd";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const CONTACT_API_BASE =
  process.env.REACT_APP_CONTACT_API_BASE_URL ||
  process.env.REACT_APP__API_BASE_URL ||
  "https://contact.api.riolabz.com/";
const COMPANY_NAME = "Dhtech";

const checkboxDataOne = [
  "Contracting & Maintenance of Residential & Industrial buildings",
  "Flooring & Tiling works",
  "Plastering, Painting & Carpentry works",
  "Plumbing & Sanitary works",
  "Interlock Pavements",
  "Dry wall partition and False Ceiling works",
  "Interior decoration works",
  "Fire Fighting works",
];

const checkBoxDataTwo = [
  "Metal Cladding Works",
  "Roof water proofing and concrete protection works",
  "Industrial Floor Coatings",
  "Decorative painting systems",
  "Reclamation works",
  "Fencing works",
  "Electrical repairing works",
  "General Maintenance",
];

const QuotePageContents = () => {
  const [checkedList, setCheckedList] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    contactOption: "",
    aboutOrganization: "",
    overviewOrganization: "",
    projectDetails: "",
    organizationTypes: [],
    file: null,
  });
  const [showCheckboxError, setShowCheckboxError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [showRadioError, setShowRadioError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!showToast) return;
    const t = setTimeout(() => setShowToast(false), 5000);
    return () => clearTimeout(t);
  }, [showToast]);

  const onChange = (checkedValue) => {
    const updatedCheckedList = checkedList.includes(checkedValue)
      ? checkedList.filter((item) => item !== checkedValue)
      : [...checkedList, checkedValue];

    setCheckedList(updatedCheckedList);
    setFormData({
      ...formData,
      organizationTypes: updatedCheckedList,
    });

    if (updatedCheckedList.length > 0) {
      setShowCheckboxError(false);
    }
  };

  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    setFormData({
      ...formData,
      contactOption: e.target.value,
    });
    setShowRadioError(false); // Reset radio button error when user makes a selection
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phoneNumber: value || "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasValidationError = false;

    if (!selectedOption) {
      setShowRadioError(true);
      hasValidationError = true;
    }

    if (checkedList.length === 0) {
      setShowCheckboxError(true);
      hasValidationError = true;
    }

    if (hasValidationError) return;

    setIsLoading(true);
    setShowToast(false);

    const url = `${CONTACT_API_BASE.replace(/\/$/, "")}/api/quote/public/create`;

    const body = new FormData();
    body.append("company", COMPANY_NAME);
    body.append("name", formData.name);
    body.append("email", formData.email);
    body.append("phoneNumber", formData.phoneNumber);
    body.append("contactOption", formData.contactOption);
    body.append("aboutOrganization", formData.aboutOrganization);
    body.append("overviewOrganization", formData.overviewOrganization);
    body.append("projectDetails", formData.projectDetails);
    formData.organizationTypes.forEach((type) =>
      body.append("organizationTypes", type)
    );
    if (formData.file) {
      body.append("file", formData.file);
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        body: body,
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || "Network response was not ok");
      }

      setMessage(data?.message || "Quote request submitted successfully");
      setIsSuccess(true);
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        contactOption: "",
        aboutOrganization: "",
        overviewOrganization: "",
        projectDetails: "",
        organizationTypes: [],
        file: null,
      });
      setSelectedOption("");
      setCheckedList([]);
      setShowCheckboxError(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setShowToast(true);
    } catch (error) {
      setMessage(error?.message || "Invalid quote details");
      setIsSuccess(false);
      setShowToast(true);
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {showToast && (
        <div
          className={`hero-success-toast ${!isSuccess ? "hero-success-toast--error" : ""}`}
          role="alert"
          aria-live="polite"
        >
          <i
            className={`fas ${isSuccess ? "fa-check-circle" : "fa-exclamation-circle"} hero-success-toast-icon`}
          />
          <span className="hero-success-toast-message">{message}</span>
          <button
            type="button"
            className="hero-success-toast-close"
            onClick={() => setShowToast(false)}
            aria-label="Close"
          >
            <i className="fas fa-times" />
          </button>
        </div>
      )}
      <div className="contact-us-wrapper section-padding">
        <div className="container">
          <div className="row eq-height">
            <div className="col-lg-12 col-12">
              <div className="contact-form">
                <h6 className="text-center" style={{ marginBottom: "30px" }}>
                  Looking for an estimate for your project? Fill out the details
                  and we will get back to you.
                </h6>

                <form
                  onSubmit={handleSubmit}
                  method="POST"
                  className="row"
                  id="contact-form"
                >
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Name"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        placeholder="Email"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info quote-phone-input">
                      <PhoneInput
                        international
                        defaultCountry="AE"
                        value={formData.phoneNumber}
                        onChange={handlePhoneChange}
                        placeholder="Number"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <Radio.Group
                      onChange={handleRadioChange}
                      value={selectedOption}
                    >
                      <Radio value="Call me with any questions">
                        Call me with any questions
                      </Radio>
                      <Radio value="Email only about the quote requested">
                        Email only about the quote requested
                      </Radio>
                    </Radio.Group>
                    {showRadioError && (
                      <p className="quotePageRadioOption">
                        Please select a contact option.
                      </p>
                    )}
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <textarea
                        rows={2}
                        type="text"
                        name="aboutOrganization"
                        value={formData.aboutOrganization}
                        placeholder="About Your Organization"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <textarea
                        rows={2}
                        type="text"
                        name="overviewOrganization"
                        value={formData.overviewOrganization}
                        placeholder="Organization Overview"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-12">
                    <div className="single-personal-info">
                      <textarea
                        name="projectDetails"
                        value={formData.projectDetails}
                        placeholder="Project Details"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      {checkboxDataOne.map((item) => (
                        <div key={item}>
                          <Checkbox
                            className="quote-checkbox"
                            checked={checkedList.includes(item)}
                            onChange={() => onChange(item)}
                          >
                            {item}
                          </Checkbox>
                        </div>
                      ))}
                      {showCheckboxError && checkedList.length === 0 && (
                        <p className="quotePageRadioOption">
                          Please select organization types.
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      {checkBoxDataTwo.map((item) => (
                        <div key={item}>
                          <Checkbox
                            className="quote-checkbox"
                            checked={checkedList.includes(item)}
                            onChange={() => onChange(item)}
                          >
                            {item}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <p>Attach Your File</p>
                      <input
                        ref={fileInputRef}
                        type="file"
                        name="file"
                        onChange={handleChange}
                        placeholder="Attach your File"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-12">
                    {/* <input
                      className="submit-btn"
                      type="submit"
                      defaultValue="Submit Now"
                    /> */}
                    <button
                      className="submit-btn"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <img
                          src="/img/loading-gif.gif"
                          alt="Loading..."
                          className="loading-gif"
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
                <span className="form-message" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuotePageContents;
